import ElementUI from 'element-ui'
ElementUI.Dialog.props.closeOnClickModal.default = false
